import type { IconProps } from '../types/IconProps.ts';
export const CreditCardPlus: IconProps = {
    name: 'CreditCardPlus',
    children: [
        `<path d="M2 10v7c0 1.1.9 2 2 2h7m-9-9V7c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v3M2 10h20m0 0v3M15 18h6M18 15v6" />`,
    ]
};